export default "__VITE_ASSET__6c8ebeeb__"